import { Component, Input } from '@angular/core';
import { FileUploadLogs } from 'src/app/shared/services/files/FileUploadLogs';
import { UploadStatus } from 'src/app/shared/services/files/UploadStatus.enum';

@Component({
  selector: '[digires-file-log]',
  templateUrl: './file-log.component.html',
  styleUrl: './file-log.component.scss'
})
export class FileLogComponent {
  @Input() log: FileUploadLogs;

  getServiceName() {
    switch (this.log.uploadService) {
      case 'SnapshotExportService.uploadTargetTableDataInternal':
        return 'MinIO';
      case 'PowerBiExportService.uploadTargetTableData':
        return 'ASB';
      default:
        return 'Unknown';
    }
  }
}
